import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { SITE } from '../data/site';

interface CtaBandProps {
  eyebrow?: string;
  title?: ReactNode;
  primary?: { label: string; to: string };
  secondary?: { label: string; href: string };
}

/** Footer's top band. Also usable mid-page as a standalone conversion moment. */
function CtaBand({
  eyebrow = 'READY TO START?',
  title = "Let's build something that actually runs.",
  primary = { label: 'Start a conversation', to: '/contact' },
  secondary = { label: 'or book a 15-min call ↗', href: SITE.calendly },
}: CtaBandProps) {
  return (
    <div className="cta-band">
      <div className="container cta-band-inner">
        <div className="cta-band-text">
          <span className="cta-band-eyebrow">{eyebrow}</span>
          <h3 className="cta-band-title">{title}</h3>
        </div>
        <div className="cta-band-actions">
          <Link to={primary.to} className="btn-primary">
            {primary.label}
          </Link>
          <a
            href={secondary.href}
            target="_blank"
            rel="noopener noreferrer"
            className="cta-band-secondary"
          >
            {secondary.label}
          </a>
        </div>
      </div>
    </div>
  );
}

export default CtaBand;
